import { Space,  Col, Row, Icon, Field, CellGroup, Sticky   } from 'vant';
import {CONSTANTS} from "@/helpers/constants";

export default {
    name: 'Payment Success',
    components: {
        [Space.name]: Space,
        [Col.name]: Col,
        [Row.name]: Row,
        [Icon.name]: Icon,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [Sticky.name]: Sticky,
    },
    data() {
        return {
            message: null,
            data: null,
        };
    },
    created() {
        this.data = this.$route.query;
    },
    mounted() {
    },
    methods: {
        color_primary() {
            return CONSTANTS.color_primary
        },
        formatPhoneNumberTwo(phoneNumber) {
            if (!phoneNumber) return "";
            const digits = String(phoneNumber)
                .trim()
                .replace(/\s+/g, "")
                .replace(/\D/g, "");
            if (!digits) return "";

            let normalized = digits;
            if (!digits.startsWith("0") && !digits.startsWith("855")) {
                normalized = "0" + digits;
            }

            if (normalized.length >= 3) {
                return normalized.replace(/(\d{3})(\d{3})(.*)/, "$1 $2 $3");
            }
            return normalized;
        },
        goHome(){
            this.$router.replace("/home")
        },
        fixedPrice(price){
            if(price){
                let priceNumber = parseFloat(price)
                return priceNumber.toFixed(2);
            }
            return price;
        }
    },
    beforeUnmount() {
    },
}
